export const PAYMENT_STATUSES = ['pending', 'authorized', 'captured', 'failed', 'refunded', 'partially_refunded'] as const;
export type PaymentStatus = (typeof PAYMENT_STATUSES)[number];

export const PAYMENT_METHODS = ['razorpay', 'cod'] as const;
export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export const REFUND_STATUSES = ['pending', 'processed', 'failed'] as const;
export type RefundStatus = (typeof REFUND_STATUSES)[number];

export interface AdminPaymentListItem {
  id: string;
  orderId: string;
  method: string;
  status: string;
  amountPaise: number;
  razorpayPaymentId: string | null;
  razorpayOrderId: string | null;
  capturedAt: string | null;
  failureReason: string | null;
  createdAt: string;
  updatedAt: string;
  orderNumber: string;
  customerName: string | null;
  customerEmail: string;
}

export interface AdminPaymentAttempt {
  id: string;
  attemptNumber: number;
  status: string;
  razorpayPaymentId: string | null;
  errorCode: string | null;
  errorDescription: string | null;
  attemptedAt: string;
}

export interface AdminRefund {
  id: string;
  razorpayRefundId: string | null;
  amountPaise: number;
  reason: string | null;
  status: string;
  initiatedAt: string;
  processedAt: string | null;
}

export interface AdminPaymentDetail {
  payment: AdminPaymentListItem;
  attempts: AdminPaymentAttempt[];
  refunds: AdminRefund[];
}

export interface AdminRefundListItem extends AdminRefund {
  orderNumber: string;
}

export interface PaymentListParams {
  status?: PaymentStatus[];
  method?: PaymentMethod[];
  orderNumber?: string;
  customerSearch?: string;
  dateFrom?: string;
  dateTo?: string;
  minAmountPaise?: number;
  maxAmountPaise?: number;
  sortField?: 'createdAt' | 'amountPaise';
  sortDirection?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
}

export interface RefundListParams {
  status?: RefundStatus[];
  orderNumber?: string;
  dateFrom?: string;
  dateTo?: string;
  minAmountPaise?: number;
  maxAmountPaise?: number;
  limit?: number;
  offset?: number;
}

export interface InitiateRefundInput {
  amountPaise?: number;
  reason?: string;
}

export interface InitiateRefundResult {
  refundId: string;
  status: string;
  amountPaise: number;
  paymentStatus: string;
  orderId: string;
}
